module.exports = __webpack_public_path__ + "static/media/imageVideo.5503ed91.jpeg";